import { render } from "./VerticalAlignmentPage.vue?vue&type=template&id=759fec91&ts=true"
import script from "./VerticalAlignmentPage.vue?vue&type=script&lang=ts"
export * from "./VerticalAlignmentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__